// What to tell the doctor after a PP submission, keyed on the outcome the
// backend reports (PpService.SubmissionOutcomeStatus).
//
// "Moving to CDM" is a clinical claim, so it is stated only when the backend
// actually says so. This was previously a two-way ternary — anything that was
// not REMAIN_ON_PREVENTION_PROGRAMME was reported as a move to CDM — which made
// every new outcome a false statement by default. SUBMITTED_AWAITING_ACKNOWLEDGEMENT
// (async PCRS acks) would have told doctors their patient was being moved to CDM
// on every single PP submission.
const PP_SUBMIT_MESSAGES = {
  REMAIN_ON_PREVENTION_PROGRAMME: "PP sent successfully",
  MOVED_TO_CHRONIC_DISEASE_MANAGEMENT:
    "PP sent successfully, but patient will be moved to CDM",
  // A successful send is now only in-flight: PCRS acknowledges asynchronously,
  // and that ACK is what finalises the review.
  SUBMITTED_AWAITING_ACKNOWLEDGEMENT:
    "PP sent — awaiting PCRS acknowledgement",
};

const PP_SUBMIT_FALLBACK_MESSAGE = "PP sent successfully";

/**
 * The submission succeeded either way, so an unrecognised outcome falls back to
 * plain success: it is the one message that is true of every outcome, and it
 * cannot invent a programme change that did not happen.
 */
export const getPpSubmitMessage = (outcomeStatus) =>
  PP_SUBMIT_MESSAGES[outcomeStatus] ?? PP_SUBMIT_FALLBACK_MESSAGE;
